import React from 'react';
import { motion } from 'framer-motion';
const reasons = [{
  title: 'IUL Specialists',
  description: 'We focus exclusively on indexed universal life insurance, giving you access to deep expertise in this powerful financial tool.'
}, {
  title: 'Education-First',
  description: 'We take time to explain how IUL life insurance works so you can make confident, informed decisions about your future.'
}, {
  title: 'Personalized Solutions',
  description: 'No cookie-cutter approaches. Every indexed universal life policy is designed around your unique goals and circumstances.'
}, {
  title: 'Long-Term Partnership',
  description: "We're here for the life of your policy, providing ongoing support, annual reviews, and guidance as your life and goals evolve."
}];
export function WhyChooseUs() {
  return <section className="py-20 md:py-28 bg-cream px-6" data-id="element-180">
      <div className="max-w-[1100px] mx-auto" data-id="element-181">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-182">
          <h2 className="text-3xl md:text-4xl font-bold text-forest mb-4" data-id="element-183">
            Why Clients Choose Us
          </h2>
          <p className="text-charcoal/80 text-lg" data-id="element-184">
            Specialized Indexed Universal Life insurance advice, delivered with
            clarity, education, and long-term commitment.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-185">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-186">
              <h3 className="text-lg font-bold text-forest mb-3" data-id="element-187">
                {reason.title}
              </h3>
              <p className="text-charcoal/70 text-sm leading-relaxed" data-id="element-188">
                {reason.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}